<template>
  <PForm
    v-model="validado"
    @cancel="limpiar"
    @accept="action"
    :action="actionName"
    :textAction="textActionName"
    :textCancel="$t('action.limpiar')"
  >
    <template>
      <PRow>
        <PCol md="12">
          <PFormDatepicker
            v-model="valueLocal.fecCertificadoInicio"
            :label="$t('label.fechaInicio')"
            :endSelector="valueLocal.fecCertificadoFin"
            :language="locale"
            :utcDate="true"
          />
        </PCol>
        <PCol md="12">
          <PFormDatepicker
            v-model="valueLocal.fecCertificadoFin"
            :label="$t('label.fechaFin')"
            :startSelector="valueLocal.fecCertificadoInicio"
            :maxToday="true"
            :maxRangeMonth="maxRange"
            :language="locale"
            :utcDate="true"
          />
        </PCol>
        <PCol md="12">
          <PFormSelectMulti
            v-model="valueLocal.delegationsSelected"
            :options="delegations"
            optionValue="id"
            optionText="desDelegacion"
            :label="$t('label.delegaciones')"
            :placeholder="$t('option.select')"
            :readonly="this.clienteSelected?.id === undefined"
          />
        </PCol>
      </PRow>
    </template>
  </PForm>
</template>
<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { Locale } from "@/store";
import { ICliente, IDelegacion } from "@/entities";
import VueMethods from "@/vue-methods";
import { MAX_RANGE_MONTH_DATE } from "@/constans";

@Component({
  mixins: [VueMethods],
})
export class SaldosTodosFiltersForm extends Vue {
  @Prop({ required: true }) value!: any;
  @Watch("value", { immediate: true, deep: true })
  onChangeValue(): void {
    this.valueLocal = JSON.parse(JSON.stringify(this.value));
    this.$set(
      this.valueLocal,
      "fecCertificadoInicio",
      this.valueLocal.fecCertificadoInicio
        ? new Date(this.valueLocal.fecCertificadoInicio!).toISOString()
        : this.getStartLocalDate(new Date().toISOString())
    );
    this.$set(
      this.valueLocal,
      "fecCertificadoFin",
      this.valueLocal.fecCertificadoFin
        ? new Date(this.valueLocal.fecCertificadoFin!).toISOString()
        : this.getEndLocalDate(new Date().toISOString())
    );
  }
  valueLocal = {
    fecCertificadoInicio: this.getStartLocalDate(new Date().toISOString()),
    fecCertificadoFin: this.getEndLocalDate(new Date().toISOString()),
    delegationsSelected: [],
  };
  initialValueLocal = {
    fecCertificadoInicio: this.getStartLocalDate(new Date().toISOString()),
    fecCertificadoFin: this.getEndLocalDate(new Date().toISOString()),
    delegationsSelected: [],
  };
  @Prop({ required: false }) actionName!: string;
  @Prop({ required: false }) textActionName!: string;
  @Getter("getLocale") locale!: Locale;
  @Getter("getClienteSelected") clienteSelected!: ICliente;
  validado = false;

  maxRange = MAX_RANGE_MONTH_DATE;

  limpiar(): void {
    this.$set(
      this.valueLocal,
      "fecCertificadoInicio",
      this.getStartLocalDate(new Date().toISOString())
    );
    this.$set(this.valueLocal, "fecCertificadoFin", this.getEndLocalDate(new Date().toISOString()));
    this.valueLocal.delegationsSelected = [];
    if (!this.isInitialObject(this.value, this.initialValueLocal)) {
      this.$emit("input", this.valueLocal);
      this.$emit("cancel", { action: "clean" });
    }
  }
  action(action: string): void {
    this.$emit("input", this.valueLocal);
    this.$emit("action", { data: this.valueLocal, action: action });
  }

  get delegations(): IDelegacion[] {
    let delegationsList: IDelegacion[] = [];
    this.clienteSelected?.clientexdels.forEach((clientexdel) => {
      if (clientexdel.active) delegationsList.push(clientexdel.delegacion);
    });
    return delegationsList.sort((a, b) => this.sortAscending(a, b, "desDelegacion"));
  }
}
export default SaldosTodosFiltersForm;
</script>
